<!-- <section *ngIf="instructionsStatus() != '1' && (platform.ANDROID || platform.IOS)" id="instructions">
    <div class="fnd_lightbox">
        <div class="d-block text-center box-instructions">
            <img src="../../../assets/img/pinch_zoom.png">
            <p>
                1. Use os dois dedos para aplicar/remover zoom. <br> 2. Clique segure e arraste para mover o mapa
            </p>
            <button (click)="okUnderstand()" class="btn btn-info btn-outline">OK, ENTENDI</button>
        </div>
    </div>
</section> -->

<div class="text-center mt-5 d-flex justify-content-center" [class.hide]="!loadingMap">
    <app-spinner type="grow" spinnerWidth="111"></app-spinner>
    <!-- <i style="font-size:55px; margin:140px 0;" class="fa fa-circle-o-notch fa-spin fa-fw"></i> -->
</div>
<div class="d-flex bd-highlight" [class.hide]="loadingMap">
    <div class="p-2 flex-grow-1 bd-highlight">
        <div id="box-map-place" class="d-block" style=" width:100%; height: 350px; overflow: hidden; z-index:999999;">
            <div style="overflow:hidden;  border:solid 2px #EEEEEE; background: #ffffff;" id="canvas"></div>
        </div>
    </div>

    <div class="d-block text-center">
        <mat-slider [style.height]="getHeightZoomBar()+'px'" [step]="'0.1'" [min]="'0.1'" [max]="'5'" (change)="changeZoomSlider()" [(ngModel)]="scale" style="width: 100%; right: 63px" vertical></mat-slider>
    </div>
</div>



<!-- Button trigger modal -->

<!-- Modal -->
<ng-template #selectTicketPlace>
    <form *ngIf="loadingModal == false" id="modalForm" (ngSubmit)="submitSelectedTickets()">
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{selectedTicketName}} <b *ngIf="selectedTicketName != ''">-</b> {{selectedPlace.attrs.name}}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: 391px; overflow: auto;">
        <section class="modal-place-top" *ngIf="selectedPlace.attrs.configs.type=='single'">
            <!-- <p>Capacidade de pessoas no lugar: <b>{{selectedPlace.attrs.configs.qtdPerson}}</b></p> -->
            <p>Total: <b>R$ {{priceTotalPlace()  | number:'1.2-2'}}</b></p>
            <p *ngIf="selectedTicketName != ''">{{selectedTicketName}}</p>
        </section>
        <section class="modal-place-top" *ngIf="selectedPlace.attrs.configs.type=='shared'">
            <div *ngIf="isEspecialEvent">
                <p><b>Mesa com 4 cadeiras (Podendo adicionar até 2 cadeiras extras)</b></p>
                <p><b>Disponível</b>: {{selectedPlace.attrs.configs.qtdDisponible}}</p>
                <p><b>Total</b>: R$ {{priceTotalPlace() | number:'1.2-2'}}</p>
            </div>
            <div *ngIf="!isEspecialEvent">
                <!-- <p><b>Capacidade de pessoas no lugar </b>: {{selectedPlace.attrs.configs.qtdPerson}}</p> -->
                <p><b>Disponível</b>: {{selectedPlace.attrs.configs.qtdDisponible}}</p>
                <p><b>Total</b>: R$ {{priceTotalPlace() | number:'1.2-2'}}</p>
            </div>          
        </section>
      
        <section [class.d-none]="!modalShowSelectTickets">
            <div *ngFor="let p of ticketSelectForm.controls; let i = index;" class="d-flex bd-highlight">
                <div class="p-2 flex-grow-1 bd-highlight">
                    <div class="form-group">
                        <label>Pessoa {{i+1}}</label><br>
                        <!--<select [formControl]="p.get('dateTicketId')" class="form-control">
          <option value="">Selecionar ingresso</option>
          <option *ngFor="let ticket of permittedTicketsFromPlace;" [value]="ticket.ticketDateId">{{ticket.ticketName}} - {{ticket.lotName}} R$ {{ util.toCurrency(ticket.unitPrice) }}</option>
        </select>-->

        <ng-select placeholder="Selecione o ingresso"
        #dateTicketId
        [items]="permittedTicketsFromPlace"
        [searchable]="true"
        bindLabel="ticketName"
        bindValue="ticketDateId"
        (change)="getTicketChange($event)"
        [formControl]="$any(p).get('dateTicketId')">
            <ng-template ng-option-tmp let-item="item" let-index="index">
                <p *ngIf="item.finished =='Esgotado'"> <b style="color:red">Esgotado</b> {{item.ticketName}}<br> {{item.lotName}} - R$ {{item.unitPrice | number:'1.2-2'}}</p>
                <p *ngIf="item.finished !=='Esgotado'">{{item.ticketName}}<br> {{item.lotName}} - R$ {{item.unitPrice | number:'1.2-2'}}</p>
            </ng-template>
        </ng-select>

                        <!-- <ng-select placeholder="Selecione o ingresso" [formControl]="p.get('dateTicketId')" #dateTicketId [items]="permittedTicketsFromPlace" [searchable]="false" bindLabel="ticketName" bindValue="ticketDateId">
                            <ng-template ng-header-tmp>
                                <input style="width: 100%; line-height: 24px" type="text" (input)="dateTicketId.filter($event.target.value)" />
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <p>{{item.ticketName}}<br> {{item.lotName}} - R$ {{item.unitPrice | number:'1.2-2'}}</p>
                            </ng-template>
                        </ng-select> -->

                        <small style="color:red;" [class.hide]="(!ticketSelectFormShowError) || (p.get('dateTicketId')?.value)">Selecione o ingresso</small>
                    </div>
                </div>
                <div (click)="removeTicket(i)" *ngIf="selectedPlace.attrs.configs.type =='shared'" class="p-2 bd-highlight">
                    <br>
                    <a class="btn btn-info btn-rounded btn-remove mt-2">x</a>
                </div>
            </div>
        </section>

        <div class="row">
          <div class="col-md-12 text-right mt-4" style="text-align: right;">
            <button *ngIf="((selectedPlace.attrs.configs.qtdDisponible) > ticketSelectForm.value.length)" (click)="newTicket()"
              type="button" class="btn btn-success btn-grad">Adicionar cadeira extra</button>
          </div>
        </div>

        <div *ngIf="ticketDescription != null && ticketDescription != ''" class="mb-3 mt-3">
            <p [innerHTML]="ticketDescription"></p>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="onEditPlace" type="button" class="btn btn-danger" (click)="cancelPlace()">Remover Reserva</button>
        <button form="modalForm" type="submit" class="btn btn-success btn-grad">
            <app-spinner type="grow" spinnerWidth="21" [class.hide]="!loadingConfirmPlace"></app-spinner>  Confirmar
         </button>
    </div>


  </form>
</ng-template>
